import { useState } from 'react';
import { Link } from 'react-router-dom';
import { allProducts } from '../../../mocks/products';

const categories = ['All', 'Industrial', 'Professional', 'Desktop'];

const ProductsSection = () => {
  const [activeCategory, setActiveCategory] = useState('All');

  const filteredProducts =
    activeCategory === 'All'
      ? allProducts.slice(0, 6)
      : allProducts.filter((p) => p.category === activeCategory).slice(0, 6);

  return (
    <section id="products" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="text-emerald-500 font-semibold text-sm tracking-wider uppercase">
            Our Products
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mt-3 mb-4">
            CO2 Laser Machines
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Professional laser cutting and engraving solutions for wood, acrylic,
            leather, fabric and more.
          </p>
        </div>

        <div className="flex justify-center gap-2 mb-12">
          {categories.map((cat) => (
            <button
              key={cat}
              onClick={() => setActiveCategory(cat)}
              className={`px-5 py-2.5 rounded-full text-sm font-medium transition-all whitespace-nowrap ${
                activeCategory === cat
                  ? 'bg-emerald-500 text-white shadow-lg shadow-emerald-500/25'
                  : 'bg-white text-gray-600 hover:bg-gray-100'
              }`}
            >
              {cat}
            </button>
          ))}
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12" data-product-shop>
          {filteredProducts.map((product) => (
            <Link
              key={product.id}
              to={`/product/${product.id}`}
              className="group bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-500"
            >
              <div className="relative h-64 overflow-hidden bg-gray-100">
                {product.badge && (
                  <span className="absolute top-4 left-4 z-10 px-3 py-1 bg-emerald-500 text-white text-xs font-semibold rounded-full">
                    {product.badge}
                  </span>
                )}
                <img
                  src={product.image}
                  alt={product.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity"></div>
              </div>
              <div className="p-6">
                <span className="text-emerald-500 text-sm font-medium">
                  {product.subtitle}
                </span>
                <h3 className="text-xl font-bold text-gray-900 mt-1 mb-2 group-hover:text-emerald-600 transition-colors">
                  {product.title}
                </h3>
                <p className="text-gray-600 text-sm mb-4 line-clamp-2">
                  {product.description}
                </p>
                <div className="flex flex-wrap gap-2 mb-4">
                  {product.specs.slice(0, 2).map((spec, i) => (
                    <span
                      key={i}
                      className="px-3 py-1 bg-gray-100 text-gray-600 text-xs rounded-full"
                    >
                      {spec.label}: {spec.value}
                    </span>
                  ))}
                </div>
                <div className="flex items-center text-emerald-500 font-semibold text-sm">
                  <span className="whitespace-nowrap">View Details</span>
                  <i className="ri-arrow-right-line ml-2 group-hover:translate-x-2 transition-transform"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center">
          <Link
            to="/products"
            className="inline-flex items-center gap-2 px-8 py-4 bg-emerald-500 text-white font-semibold rounded-full hover:bg-emerald-600 transition-all whitespace-nowrap"
          >
            <span>View All Products</span>
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ProductsSection;
